<template>
  <div class="app-substitute-sim-card-select">
    <b-form>
      <slot name="txtBefore"></slot>
      <b-form-group :label="lblBeforeSimType">
        <b-form-radio v-model="_simCardType" name="simType" value="COMBI"><slot name="lblCombiSim">Kombi SIM-Karte</slot></b-form-radio>
        <b-form-radio v-model="_simCardType" name="simType" value="NANO"><slot name="lblNanoSim">Nano SIM-Karte</slot></b-form-radio>
      </b-form-group>
      <slot name="txtAfter">
        <p>Ihre SIM-Karte wurde gestohlen? Oder Sie vermuten Mißbrauch? Wenden Sie sich am besten schnellstmöglich an unsere Hotline.</p>
      </slot>
      <Stepper
        :show-prev="false"
        @next="next()">
        <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Stepper>
    </b-form>
  </div>
</template>

<script>
import processSteps from '@/mixins/processSteps'
import Stepper from '@/components/generic/Stepper.vue'
import { mapMutations, mapState } from 'vuex'
import slotProxy from '@/mixins/slotProxy'

export const stepName = 'selectSimCard'

export default {
  name: 'SelectSimCard',
  components: { Stepper },
  props: {
    lblBeforeSimType: { type: String, default: '' }
  },
  mixins: [
    processSteps(stepName),
    slotProxy(['Stepper'])
  ],
  methods: {
    ...mapMutations('substituteSimCard', [
      'changeStep',
      'setSimCardType'
    ]),
    next () {
      this.changeStep({ step: this.nextStep })
    },
    prev () {
      this.changeStep({ step: this.previousStep })
    }
  },
  computed: {
    _simCardType: {
      get: function () {
        return this.simCardType
      },
      set: function (value) {
        this.setSimCardType({ simCardType: value })
      }
    },
    ...mapState('substituteSimCard', {
      simCardType: state => state.simCardType
    })
  }
}
</script>
